<core-spinner *ngIf="vm.isLoading"></core-spinner>

<div class="container-fluid" *ngIf="!vm.isOpening">
  <form>
      <cli-landing-header></cli-landing-header>
    <div class="row">
        <div class="col-xl-2 col-lg-1 "></div>
      <div class="col-xl-2 col-lg-2 col-md-3  pt-4 ">
        <cli-landing-menu></cli-landing-menu>
      </div>
      <div class="col-xl-6 col-lg-8 col-md-9 pt-4">
    
        <div class="row  welcome-text  ">
          <div class="col">Hydrotrak Operations</div>
        </div>

        <div class="row pb-2">
            <div class="col">It is a requirement for all new permit holders to watch hydrotrak operations video </div>
          </div>

        <div class="row pb-2">
          <div class="col align-center">
            
            <iframe width="700" height="400"
            src="https://www.youtube-nocookie.com/embed/kNUBf7GMk9A?rel=0" frameborder="0"
            allowfullscreen></iframe>
          </div>
        </div>

        
        <div class="row pb-2" >
          <div class="col pt-2">
            <div class="alert alert-primary">
              <strong>Application successfully lodged.</strong>
              <p>                
                Your hydrant permit application was successfully lodged. South East Water will be in touch with you after we review the information supplied with your application.  
                <br><br>                                               
                Water <strong>must not</strong> be taken from hydrants until a permit is issued.
              </p>
            </div>
          </div>
        </div>


      </div>
      <div class="col-xl-2 col-lg-1"></div>
    </div>

    <cli-landing-footer></cli-landing-footer>
  </form>
</div>